(function (module) {
    "use strict";

    module.service("forecastInitializationService", [
        "$http",
        "$q",
        "imsDataCommonService",
        "chamferingForecasInitService",
        "synchronousEventsBus",
        function (
            this: $TSFixMe,
            $http: ng.IHttpService,
            $q: ng.IQService,
            imsDataCommonService: $TSFixMe,
            chamferingForecasInitService: $TSFixMe,
            synchronousEventsBus: $TSFixMe
        ) {
            var service = this;

            function oragnizeImsProductsWithSameIndexes(brands: $TSFixMe) {
                const indexesDict = {};
                const duplSkus: $TSFixMe = [];

                const pushSku = (sku: $TSFixMe, brand: $TSFixMe) => {
                    const oracleIndex = sku.oracleIndex;
                    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre...
                    let entry = indexesDict[oracleIndex];
                    if (!entry) {
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre...
                        indexesDict[oracleIndex] = {
                            brandExternalIds: brand.externalIds,
                            skuExternalIds: sku.externalId ? [sku.externalId] : []
                        };
                    } else {
                        entry.skuExternalIds.push(sku.externalId);

                        for (const brandExternalId of _.difference(brand.externalIds, entry.brandExternalIds)) {
                            entry.brandExternalIds.push(brandExternalId);
                        }
                        duplSkus.push(sku.externalId);
                    }
                };

                for (var i = 0; i < brands.length; i++) {
                    const brand = brands[i];
                    for (var j = 0; j < brand.skus.length; ++j) {
                        pushSku(brand.skus[j], brand);
                    }
                }

                return { duplSkus, indexes: indexesDict };
            }

            function groupByBrands(skusIndexes: $TSFixMe) {
                const brands = [];
                for (const oracleIndex in skusIndexes) {
                    const sku = skusIndexes[oracleIndex];

                    let brand = _.find(
                        brands,
                        (x: $TSFixMe) =>
                            x.brandExternalIds &&
                            sku.brandExternalIds &&
                            imsDataCommonService.arraysAreEqual(x.brandExternalIds, sku.brandExternalIds)
                    );
                    let skuEntry = {
                        oracleIndex: oracleIndex,
                        skuExternalIds: sku?.skuExternalIds?.filter((x: $TSFixMe) => x != null)
                    };
                    if (!brand) {
                        brands.push({
                            brandExternalIds: sku.brandExternalIds,
                            skus: [skuEntry]
                        });
                    } else {
                        brand.skus.push(skuEntry);
                    }
                }

                return brands;
            }

            function removeDuplicatesFromMarketBrands(brands: $TSFixMe, duplSkus: $TSFixMe) {
                for (const duplSkuId of duplSkus) {
                    var brandIndex;

                    if (
                        (brandIndex = _.findIndex(brands, (b: $TSFixMe) =>
                            _.some(b.skus, (s: $TSFixMe) => duplSkuId == s.externalId)
                        )) > -1
                    ) {
                        var skuIndex;

                        if (
                            (skuIndex = _.findIndex(
                                brands[brandIndex].skus,
                                (s: $TSFixMe) => duplSkuId == s.externalId
                            )) > -1
                        ) {
                            brands[brandIndex].skus.splice(skuIndex, 1);

                            if (!_.any(brands[brandIndex].skus)) {
                                brands.splice(brandIndex, 1);
                            }
                        }
                    }
                }
            }

            service.findDuplicatedOracleIndex = function (forecast: $TSFixMe) {
                const map: Record<string, string[]> = {};

                const duplicatedOracleIndexes = _.chain(forecast.market.brands)
                    .map(x => x.skus)
                    .flatten()
                    .groupBy("oracleIndex")
                    .filter(v => v.length > 1)
                    .flatten()
                    .map(x => x.oracleIndex)
                    .uniq()
                    .value();

                for (const oracleIndex of duplicatedOracleIndexes) {
                    map[oracleIndex] = _.chain(forecast.market.brands)
                        .filter(b => _.some(b.skus, s => s.oracleIndex == oracleIndex))
                        .map(b => b.name)
                        .value();
                }

                return map;
            };

            service.initializeForecast = function (forecastId: $TSFixMe, forecast: $TSFixMe, forecastUId: $TSFixMe) {
                const { duplSkus, indexes } = oragnizeImsProductsWithSameIndexes(forecast.market.brands);
                let brandGroups = groupByBrands(indexes);
                removeDuplicatesFromMarketBrands(forecast.market.brands, duplSkus);

                var defer = $q.defer();
                $http({
                    method: "POST",
                    url: `/api/market/${forecast.parameters.dataSource.urlPart}/forecastInitialData`,
                    data: {
                        forecastId: forecastId,
                        marketId: forecast.market.id,
                        forecastType: forecast.parameters.forecastType.typeId,
                        historicalDataStartMonth: forecast.parameters.historicalDataStart,
                        historicalDataEndMonth: forecast.parameters.historicalDataEnd,
                        forecastStartMonth: forecast.parameters.forecastStartDate,
                        forecastEndMonth: forecast.parameters.forecastEndDate,
                        brandGroups: brandGroups
                    }
                }).then(
                    (response: $TSFixMe) => {
                        if (["scoringCards", "scoringCardsPoland"].includes(forecast.parameters.dataSource.urlPart)) {
                            chamferingForecasInitService.initialize(forecast, response).then(
                                () => defer.resolve(),
                                (response: $TSFixMe) => defer.reject(response)
                            );
                        } else {
                            initializeForecastProcessData(forecast, response, forecastUId).then(
                                () => defer.resolve(),
                                (response: $TSFixMe) => defer.reject(response)
                            );
                        }
                    },
                    (response: $TSFixMe) => defer.reject(response)
                );

                return defer.promise;
            };

            function initializeForecastProcessData(forecast: $TSFixMe, response: $TSFixMe, forecastUId: $TSFixMe) {
                var forecastLength =
                    moment
                        .utc(forecast.parameters.forecastEndDate)
                        .diff(moment.utc(forecast.parameters.forecastStartDate), "months") + 1;

                forecast.imsDataTimestamp = response.data.imsImportDate;
                forecast.imtDataToMonth = response.data.imsDataTo;

                initializeMarketForecast(forecast, forecastUId);
                imsDataCommonService.updateHistoricalDataForMarketForecast(
                    forecast.market.forecast,
                    response.data.market,
                    forecast.parameters
                );
                forecast.market.forecast.yearlyAveragePrice = response.data.marketAveragePrice;
                forecast.market.forecast.dataAfterCorrection = forecast.market.forecast.historicalData.slice();

                var promises = [];
                if (forecast.parameters.forecastMethod.methodId == "mktsh") {
                    initializeMkshrForecast(forecast, response, forecastLength);
                } else if (forecast.parameters.forecastMethod.methodId == "sku") {
                    promises = initializeSkuForecast(forecast, response, forecastLength, forecastUId);
                }
                promises.push(
                    synchronousEventsBus.$broadcast("dataAfterCorrectionChanged", {
                        forecast: forecast.market.forecast,
                        parameters: forecast.parameters
                    })
                );
                return $q.all(promises);
            }

            function initializeMkshrForecast(forecast: $TSFixMe, response: $TSFixMe, forecastLength: $TSFixMe) {
                for (var brandGroup of forecast.market.brands) {
                    var brandGroupServerData = _.find(response.data.brandGroups, (b: $TSFixMe) =>
                        imsDataCommonService.arraysAreEqual(brandGroup.externalIds, b.brandExternalIds)
                    );
                    initializeBrandForecastForMkshr(
                        brandGroup,
                        brandGroupServerData,
                        forecastLength,
                        forecast.parameters
                    );
                    if (brandGroupServerData) {
                        imsDataCommonService.updateBrandHistoricalDataForMkshrForecast(
                            brandGroup,
                            brandGroupServerData,
                            forecastLength,
                            forecast.parameters
                        );

                        var skuData = imsDataCommonService.prepareSkuData(
                            brandGroupServerData.skus,
                            brandGroupServerData.historicalData,
                            forecast.parameters.forecastType.typeId
                        );
                        for (var sku of brandGroup.skus) {
                            var serverSku = _.find(skuData, (s: $TSFixMe) => s.oracleCode == sku.oracleIndex);

                            initializeSkuForecastForMkshr(sku, serverSku, forecastLength, forecast.parameters);
                            if (serverSku) {
                                imsDataCommonService.updateSkuHistoricalDataForMkshrForecast(
                                    sku,
                                    serverSku,
                                    forecastLength,
                                    forecast.parameters
                                );
                            }
                        }
                    } else {
                        imsDataCommonService.updateBrandHistoricalDataForMkshrForecast(
                            brandGroup,
                            {
                                historicalData: {
                                    value: [],
                                    mkshr: [],
                                    dot: [],
                                    volume: []
                                }
                            },
                            forecastLength,
                            forecast.parameters
                        );

                        for (var sku of brandGroup.skus) {
                            initializeSkuForecastForMkshr(sku, null, forecastLength, forecast.parameters);
                            imsDataCommonService.updateSkuHistoricalDataForMkshrForecast(
                                sku,
                                {
                                    price: [],
                                    mkshr: [],
                                    data: { value: [], volume: [], dot: [] },
                                    exFactoryHistoricalData: { value: [], volume: [] }
                                },
                                forecastLength,
                                forecast.parameters
                            );
                        }
                    }
                }
            }

            function initializeSkuForecast(
                forecast: $TSFixMe,
                response: $TSFixMe,
                forecastLength: $TSFixMe,
                forecastUId: $TSFixMe
            ) {
                var promises = [];
                for (var brandGroup of forecast.market.brands) {
                    var brandGroupServerData = _.find(response.data.brandGroups, (b: $TSFixMe) =>
                        imsDataCommonService.arraysAreEqual(brandGroup.externalIds, b.brandExternalIds)
                    );

                    initializeBrandForecastForSku(
                        brandGroup,
                        brandGroupServerData,
                        forecastLength,
                        forecast.parameters
                    );
                    imsDataCommonService.updateBrandHistoricalDataForSkuForecast(
                        brandGroup,
                        brandGroupServerData,
                        forecastLength,
                        forecast.parameters
                    );

                    for (var sku of brandGroup.skus) {
                        var serverSku = _.find(
                            brandGroupServerData.skus,
                            (s: $TSFixMe) => s.oracleCode == sku.oracleIndex
                        );

                        initializeSkuForecastForSku(
                            sku,
                            serverSku,
                            brandGroupServerData,
                            forecastLength,
                            forecast.parameters,
                            forecastUId
                        );
                        promises.push(
                            synchronousEventsBus.$broadcast("dataAfterCorrectionChanged", {
                                forecast: sku.forecast,
                                parameters: forecast.parameters
                            })
                        );
                    }
                }
                return promises;
            }

            function initializeSkuForecastForSku(
                sku: $TSFixMe,
                serverSku: $TSFixMe,
                brandGroupServerData: $TSFixMe,
                forecastLength: $TSFixMe,
                parameters: $TSFixMe,
                forecastUId: $TSFixMe
            ) {
                sku.forecast = {
                    period: 1,
                    skippedStart: 0,
                    skippedEnd: 0,
                    historicalValueData: serverSku.data.value,
                    historicalPrice: [],
                    historicalBrandShr: [],
                    freezedMonths: 0,
                    freezedMonthsVolume: [],
                    correction: [],

                    price: _.times(forecastLength, _.constant(null)),
                    exFactory: imsDataCommonService.createExFactory(serverSku),
                    machineLearningData: imsDataCommonService.createMlData(forecastUId, sku.oracleIndex)
                };
                if (parameters.forecastType.typeId == "dot") {
                    sku.forecast.historicalData = serverSku.data.dot;
                } else {
                    sku.forecast.historicalData = serverSku.data.volume;
                }
                sku.forecast.dataAfterCorrection = sku.forecast.historicalData.slice();
                imsDataCommonService.calculateSkuHistoricalData(sku, serverSku, brandGroupServerData, parameters);
            }

            function initializeBrandForecastForSku(
                brandGroup: $TSFixMe,
                brandGroupServerData: $TSFixMe,
                forecastLength: $TSFixMe,
                parameters: $TSFixMe
            ) {
                brandGroup.forecast = {
                    mkshr: _.times(forecastLength, _.constant(null))
                };
            }

            function initializeSkuForecastForMkshr(
                sku: $TSFixMe,
                serverSku: $TSFixMe,
                forecastLength: $TSFixMe,
                parameters: $TSFixMe
            ) {
                sku.forecast = {
                    mkshr: _.times(forecastLength, _.constant(null)),

                    price: _.times(forecastLength, _.constant(null))
                };
            }

            function initializeBrandForecastForMkshr(
                brandGroup: $TSFixMe,
                brandGroupServerData: $TSFixMe,
                forecastLength: $TSFixMe,
                parameters: $TSFixMe
            ) {
                brandGroup.forecast = {
                    mkshr: _.times(forecastLength, _.constant(null))
                };
            }

            function initializeMarketForecast(forecast: $TSFixMe, forecastUId: $TSFixMe) {
                var startYear = parseInt(moment(forecast.parameters.forecastStartDate).format("YYYY"));

                var endYear = parseInt(moment(forecast.parameters.forecastEndDate).format("YYYY"));

                forecast.market.forecast = {
                    period: 1,
                    skippedStart: 0,
                    skippedEnd: 0,
                    freezedMonths: 0,
                    freezedMonthsVolume: [],
                    correction: [],

                    priceChangeInYears: _.times(endYear - startYear + 1, _.constant(0)),
                    machineLearningData: imsDataCommonService.createMlData(forecastUId)
                };
            }
        }
    ]);
})(angular.module("topline.services"));
